import { FlashMessageProps } from "../types/flash-messages-types";
import { ReduxState } from "../types/main-reducer-types";

export const selectFlashMessages = (state: ReduxState): FlashMessageProps[] => {
  return state.flashMessages.flashMessages;
};
